import { Mixpanel } from './mixpanel';
import { getCurrentTeacherId, isCleverTeacher } from '../services/teacher';

export const CLASSROOM_CREATED_EVENT = 'Dashboard: School_ClassroomCreated';

/**
 * Tracks a new classroom, whether a teacher created it on the Create page or
 * Clever sync created it. Catches its own errors so analytics can never break
 * the caller; safe to call without await.
 *
 * @param {object} params.teacherInfo - the Teacher from sessionStorage 'teacherData'
 * @param {string} params.classroomId - the new Classroom objectId
 * @param {Array|Promise<Array>} params.classrooms - the teacher's active classrooms
 *   after creation, or a promise for them (e.g. refreshClassrooms())
 * @param {number} params.studentCountAtCreation - students in the new classroom
 */
export const trackClassroomCreated = async ({
  teacherInfo,
  classroomId,
  classrooms,
  studentCountAtCreation,
}) => {
  try {
    const activeClassrooms = await classrooms;
    const props = {
      teacherId: getCurrentTeacherId(),
      classroomId: classroomId,
      accountSource: isCleverTeacher(teacherInfo) ? 'clever' : 'direct',
      teacherClassroomCount: activeClassrooms.length,
      studentCountAtCreation: studentCountAtCreation || 0,
    };
    Mixpanel.track(CLASSROOM_CREATED_EVENT, props);
  } catch (error) {
    console.error(`[Mixpanel] ${CLASSROOM_CREATED_EVENT} failed`, error);
  }
};
